<template>
    <div class="page clinic-list">

        <list-skeleton v-if="loading" style="margin-bottom: 100vh"></list-skeleton>

        <div class="tags" v-if="categories && categories.length > 0">
            <van-tabs v-model="category_index" @click="changeCategory" swipeable>
                <van-tab :title-class="'course-list-category-title'" v-for="(item,index) in categories" :key="item.id" :title="item.name" />
            </van-tabs>
            <div class="clear"></div>
        </div>

        <div class="global-back">
            <img src="/static/third/detail_back_btn.svg" @click="$router.back()" alt="">
        </div>

        <div v-if="list.length > 0" class="clinic-list-section">

            <div style="padding:15px 15px 0 15px; box-sizing:border-box">
                <img @click="goBytx()" :src="topic.cover_img" width="100%" alt="">
            </div>

            <div class="clinic-list-section-box" v-for="(item,i) in list" :key="item.id" style="margin-top: 15px">

                <div v-if="item.origin_type == 1" class="course-list-section" style="padding-top: 0;padding-bottom: 0">
                    <van-row @click="go_detail(item)">
                        <div class="course-list-section-box">
                            <div class="course-list-section-left" style="height: 72px">
                                <van-image
                                    fit="cover"
                                    class="course-list-section-left-img"
                                    :src="item.cover_img"
                                    width="100%"
                                    height="72"
                                />
                                <img class="course-list-section-left-play" src="/static/two/icon_viedo_play_32.svg" alt="">
                                <img v-if="item.type==2" class="course-list-section-left-zl" src="/static/two/icon_list_tag_subject_video.svg" alt="">
                            </div>
                            <div class="course-list-section-right">
                                <div class="course-list-section-right-title">{{item.title.length > 24 ? item.title.substr(0,24)+'...' : item.title}}</div>
                                <div class="course-list-section-right-detail" v-if="item.type==2">已更新{{item.current_count}}节 | 共{{item.total_count}}节</div>
                                <div class="course-list-section-right-detail" v-else>{{item.created_at}} {{item.view_count}}人学习</div>
                            </div>
                        </div>
                    </van-row>
                    <div class="clear"></div>
                </div>

                <div v-if="item.origin_type == 2" @click="go_detail(item)" class="article-list-section" style="padding-top: 0;">
                    <van-row class="article-list-section-box">
                        <van-col span="8">
                            <van-image
                                fit="cover"
                                class="article-list-content-img"
                                :src="item.cover_img"
                                width="100%"
                                height="74"
                            />
                            <div class="article-list-section-box-zl" v-if="item.type == 2">
                                <img src="/static/two/icon_list_tag_subject_text.svg" alt="">
                            </div>
                        </van-col>
                        <van-col span="16" class="article-list-content">
                            <div class="article-list-title">{{item.title.length > 24 ? item.title.substr(0,24)+'...' : item.title}}</div>
                            <div class="article-list-content-desc" v-if="item.desc">
                                {{item.desc}}
                            </div>
                            <div class="article-list-content-detail">
                                <div v-if="item.type == 2">已更新{{item.current_count}}篇 | 共{{item.total_count}}篇</div>
                                <div v-else>{{item.created_at}}<span style="margin-left: 8px">{{item.view_count}}人阅读</span></div>
                            </div>
                        </van-col>
                    </van-row>
                    <div class="clear"></div>
                </div>
                <div v-else-if="item.origin_type == 3" class="course-list-section" style="padding-top: 0;padding-bottom: 0">
                    <van-row @click="go_detail(item)">
                        <div class="course-list-section-box">
                            <div class="course-list-section-left" style="height: 72px">
                                <van-image
                                    fit="cover"
                                    class="course-list-section-left-img"
                                    :src="item.cover_img"
                                    width="100%"
                                    height="72"
                                />
                                <img class="course-list-section-left-play" src="/static/two/icon_viedo_play_32.svg" alt="">
                                <img v-if="item.type==2" class="course-list-section-left-zl" src="/static/two/icon_list_tag_subject_video.svg" alt="">
                            </div>
                            <div class="course-list-section-right">
                                <div class="course-list-section-right-title">{{item.title.length > 24 ? item.title.substr(0,24)+'...' : item.title}}</div>
                                <div class="course-list-section-right-detail" v-if="item.type==2">已更新{{item.current_count}}节 | 共{{item.total_count}}节</div>
                                <div class="course-list-section-right-detail" v-else>{{item.created_at}} {{item.view_count}}人学习</div>
                            </div>
                        </div>
                    </van-row>
                    <div class="clear"></div>
                </div>

                <div v-else-if="item.origin_type == 4" class="live-list-section" style="padding-top: 0;padding-bottom: 0">
                    <van-row @click="go_detail(item)">
                        <div class="live-list-section-box">
                            <div class="live-list-section-left">
                                <van-image
                                    class="live-list-section-left-img"
                                    fit="cover"
                                    :src="item.cover_img"
                                />
                                <img v-if="item.type==2" class="course-list-section-left-zl" src="/static/two/icon_list_tag_subject_live.svg" alt="">
                                <img v-else-if="item.live_status==0" class="live-list-section-left-zl" src="/static/img/live/icon_list_tag_live_count_down.svg" alt="">
                                <img v-else-if="item.live_status==1" class="live-list-section-left-zl" src="/static/img/live/icon_list_tag_live_process.svg" alt="">
                                <img v-else-if="item.live_status==2" class="live-list-section-left-zl" src="/static/img/live/icon_list_tag_live_history.svg" alt="">
                            </div>
                            <div class="live-list-section-right">
                                <div class="live-list-section-right-title">{{item.title.length > 24 ? item.title.substr(0,24)+'...' : item.title}}</div>
                                <div class="course-list-section-right-detail" v-if="item.type==2">已开展{{item.current_count}}节 | 共{{item.total_count}}节</div>
                                <div class="live-list-section-right-detail" v-else>{{item.start_at}}
                                    <span class="live-list-section-right-detail-join" v-if="item.live_status < 2">
                                        {{item.live_status === 0 ? item.isAppointment ? '已预约':'预约' : '加入'}}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </van-row>
                </div>
                <van-divider v-if="i < list.length-1" />
            </div>
        </div>
        <van-empty v-else description="" image="/static/img/pic_blank_content.svg" >
            <template slot="description">
                <div style="text-align: center">博医荟持续更新中…</div>
                <div style="text-align: center;margin-top: 10px">先看看其他内容吧！</div>
                <div style="text-align: center;margin-top: 24px">
                    <van-button color="#D3172E" round size="small" style="width: 120px" :to="'/'">
                        返回首页
                    </van-button>
                </div>
            </template>
        </van-empty>
    </div>
</template>
<script>
    import Interface from "@/util/interface"
    import listSkeleton from "@/skeleton/listSkeleton"
    export default {
        name: 'course-list',
        components :{
            'list-skeleton' : listSkeleton
        },
        data() {
            return {
                value: "",
                active: "",
                category_id :0,
                category_index:0,
                category_child_id:0,
                banners: [],
                categories: [],
                categories_child:[],
                recommend:[],
                list:[],
                column:[],
                loading:true,
                topic:{},

                nav_active:0,
                from_name:"",
                share_title:""
            }
        },
        methods: {
            fetchTopic() {
                Interface.getData('get', Interface.topic.detail + this.$route.params.topic_id).then((res) => {
                    this.topic = res.data

                    let title = ""
                    this.topic.modules.forEach(val=>{
                        if(val.id == this.$route.params.topic_subject_id){
                            title += val.title
                        }
                    })
                    let desc = ""
                    switch (this.topic.id) {
                        case 2:
                            desc = "一站式解锁诊断技术发展动态，行业专家亲身传授，与数万名同道共成长"
                            break
                        case 21:
                            desc = "零门槛开展临床研究的学术交流专区"
                            break
                        case 4:
                            desc = "把脉国际学术新知"
                            break
                        default:
                            desc = this.topic.desc
                            break
                    }
                    this.share_title = this.topic.title+"-"+title

                    Interface.getShareInfo(this, this.share_title, this.topic.cover_img, desc)
                })
            },
            fetch(scene) {
                if (scene === 'list_category') {
                    Interface.getData('get', Interface.topic.column_category,{
                        meeting_subject_id : this.$route.params.topic_id,
                        meeting_subject_topic_id : this.$route.params.topic_subject_id
                    }).then((res) => {
                        this.categories = res.data
                        if(this.categories.length > 0){
                            this.categories.unshift({name:"推荐",id:0})
                            if(this.categories.length < 5){
                                for(let i=999;i<= (1007 - this.categories.length);i++){
                                    this.categories_child.push({name:"",id:i})
                                }
                            }
                        }
                    })
                } else if (scene === 'list') {
                    let params = {
                        category_id : this.category_id,
                        page:1,
                        pageSize:999,
                        meeting_subject_id : this.$route.params.topic_id,
                        meeting_subject_topic_id : this.$route.params.topic_subject_id
                    }
                    if(this.value != ""){
                        params.category_id = 0
                        params.title = this.value
                    }
                    Interface.getData('get', Interface.topic.column,params).then((res) => {
                        if(res.code == 0){
                            if(res.data.list){
                                this.list = res.data.list
                            }else{
                                this.list = []
                            }
                        }
                        setTimeout(()=>{this.loading = false;},500)
                    })
                }
            },
            changeCategory(){
                this.category_id = this.categories[this.category_index].id
                this.fetch('list')
            },
            go_detail(item) {

                let content_type = this.nav_active == 0 ? 7 : 8

                if(item.origin_type === 1) {
                    //资讯
                    if(item.type == 1 || item.type === 3){
                        this.$router.push({'name':'course-detail',params:{id:item.content_id},query:{content_type:content_type}})
                        Interface.footPrint(17,item.content_id,this.topic_subject_id,"浏览"+this.share_title+"专栏的课程详情")
                    }else{
                        this.$router.push({'name':'course-column',params:{id:item.content_id},query:{content_type:content_type}})
                        Interface.footPrint(17,item.content_id,this.topic_subject_id,"浏览"+this.share_title+"专栏的课程专栏")
                    }
                }if(item.origin_type === 2) {
                    //资讯
                    if(item.type == 1 || item.type === 3){
                        Interface.footPrint(17,item.content_id,this.topic_subject_id,"浏览"+this.share_title+"专栏的资讯详情")
                    }else{
                        Interface.footPrint(17,item.content_id,this.topic_subject_id,"浏览"+this.share_title+"专栏的资讯专栏")
                    }
                    Interface.goArticle(this,item,true)
                }else if (item.origin_type === 3){
                    //视频
                    if (item.type === 1 || item.type === 3){
                        this.$router.push({name:'video-detail',params: { id: item.content_id },query:{content_type:content_type}})
                    }else{
                        this.$router.push({'name':'video-column',params:{id:item.content_id},query:{content_type:content_type}})
                    }
                }else if (item.origin_type === 4){
                    //视频
                    if (item.type === 2) {
                        this.$router.push({'name': 'live-column', params: {id: item.content_id}})
                        Interface.footPrint(17,item.content_id,this.topic_subject_id,"浏览"+this.share_title+"专栏的直播专栏")
                    } else if (item.live_status === 6) {
                        this.$router.push({'name': 'live-detail-home', params: {id: item.content_id}})
                        Interface.footPrint(17,item.content_id,this.topic_subject_id,"浏览"+this.share_title+"专栏的直播回放")
                    } else {
                        if (item.live_status === 0) {
                            this.$router.push({'name': 'live-detail', params: {id: item.content_id}})
                            Interface.footPrint(17,item.content_id,this.topic_subject_id,"浏览"+this.share_title+"专栏的直播详情")
                        } else {
                            this.$router.push({'name': 'live-detail-home', params: {id: item.content_id}})
                            Interface.footPrint(17,item.content_id,this.topic_subject_id,"浏览"+this.share_title+"专栏的直播间")
                        }
                    }
                }
            },
            goBytx(){
                if(this.$route.params.topic_id == 1){
                    //location.href = "https://bytx.care-gobroad.com/#/live-column/246"
                }
            }
        },
        created() {
            this.fetch('list')
            this.fetch('list_category')
            this.fetchTopic()
            sessionStorage.removeItem("search_data")
            Interface.footPrint(16,this.topic_subject_id,this.topic_id)
        },
    }
</script>
<style lang="scss">
    @import "./index";
</style>



// WEBPACK FOOTER //
// src/views/topic/topic-column/index.vue